var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160527",
    "data-name": "Group 160527",
    transform: "translate(-624 -640)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    "data-name": "Rectangle 1915",
    width: 16,
    height: 16,
    transform: "translate(624 640)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1916",
    "data-name": "Rectangle 1916",
    width: 10,
    height: 10,
    transform: "translate(627 643)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160526",
    "data-name": "Group 160526",
    transform: "translate(-0.499 0.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-outline_1_",
    "data-name": "person-outline (1)",
    transform: "translate(631 643.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M170.93,49.749a1.61,1.61,0,1,1-3.207,0,1.61,1.61,0,1,1,3.207,0Z",
    transform: "translate(-165.828 -48)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M67.5,304A3.351,3.351,0,0,0,64,306.526a.306.306,0,0,0,.285.39H70.7a.306.306,0,0,0,.285-.39A3.351,3.351,0,0,0,67.5,304Z",
    transform: "translate(-63.998 -299.335)",
    fill: "none",
    stroke: "#0032c5",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160525",
    "data-name": "Group 160525",
    transform: "translate(-4.766 -24.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M5.4,5.451a1.532,1.532,0,0,1-1.367,1.5,1.526,1.526,0,0,1-1.367-1.5A1.333,1.333,0,0,1,4.036,3.96,1.345,1.345,0,0,1,5.4,5.451Z",
    transform: "translate(630.7 663.5)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M5.088,9.814A3.569,3.569,0,0,0,3.566,9.52,2.861,2.861,0,0,0,.607,11.482a.258.258,0,0,0,.24.34h2.9",
    transform: "translate(631.17 662.236)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectGroupIcon);
export default __webpack_public_path__ + "static/media/MultiselectGroup-icon.efc540e5e4013f0596720f812a450314.svg";
export { ForwardRef as ReactComponent };